import { useState } from "react";
import "./CommandeForm.css";
import SquarePaymentForm from "./SquarePaymentForm";
import { PanierElement, outilListe, Outil, usePanier } from "../PanierContext";

interface CommandeProps {
  saveUserId: (customerId: string) => void;
  customerId: string;
  saveOrderId: (orderId: string) => void;
  orderId: string;
  panier: PanierElement[];
}

const locationId = "LRQ9HMBW4MQHD";

export default function CommandeForm({
                                        saveUserId,
                                        customerId,
                                        saveOrderId,
                                        orderId,
                                        panier,
                                        }: CommandeProps) {
  const [step, setStep] = useState(1);
  const { livraison } = usePanier();
  const totalSteps = 3;
  const [suggestions, setSuggestions] = useState<
    { label: string; name: string; city: string; postcode: string }[]
  >([]);
  const [status, setStatus] = useState<"SUCCESS" | "FAILURE" | "">("");

  const [formData, setFormData] = useState({
    nom: "",
    prenom: "",
    email: "",
    telephone: "",
    adresse: "",
    complement: "",
    codePostal: "",
    ville: "",
    pays: "France",
  });

  // 🔹 Récupérer les infos d’un outil à partir de son id
  const getOutil = (idOutil: number): Outil | undefined =>
    outilListe.find((o) => o.id === idOutil);

  // 🔹 Gérer les changements dans les champs du formulaire
  const handleChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLSelectElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));

    // // Recherche d’adresse
    // if (name === "adresse" && value.length > 3) {
    //   fetch(`https://api-adresse.data.gouv.fr/search/?q=${value}`)
    //     .then((res) => res.json())
    //     .then((data) => {
    //       if (data.features) {
    //         setSuggestions(
    //           data.features.map((item: any) => ({
    //             label: item.properties.label,
    //             name: item.properties.name,
    //             city: item.properties.city,
    //             postcode: item.properties.postcode,
    //           }))
    //         );
    //       }
    //     })
    //     .catch((error) => console.error("Erreur API Adresse :", error));
    // } else {
    //   setSuggestions([]);
    // }
  };

  const handleSelectAddress = (suggestion: {
    label: string;
    name: string;
    city: string;
    postcode: string;
  }) => {
    setFormData((prev) => ({
      ...prev,
      adresse: suggestion.name,
      ville: suggestion.city,
      codePostal: suggestion.postcode,
    }));
    setSuggestions([]);
  };

  // 🔹 Création de l’utilisateur
  const saveCustomerId = async (response: Response) => {
    try {
      const data = await response.json();
      if (data?.customer?.id) saveUserId(data.customer.id);
      else saveUserId("");
    } catch {
      saveUserId("");
    }
  };

  const saveCommandeId = async (response: Response) => {
    try {
      const data = await response.json();
      if (data?.order?.id) saveOrderId(data.order.id);
      else saveOrderId("");
    } catch {
      saveOrderId("");
    }
  };

  const createUser = async () => {
    const data = new URLSearchParams();
    data.append("nom", formData.nom);
    data.append("mail", formData.email);
    data.append("prenom", formData.prenom);
    data.append("telephone", formData.telephone);
    data.append("adresse", formData.adresse);
    data.append("complement_adresse", formData.complement);
    data.append("code_postal", formData.codePostal);
    data.append("ville", formData.ville);

    try {
      const response = await fetch("/backend/user.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      if (!response.ok) throw new Error("Customer creation failed");
      saveCustomerId(response);
    } catch (error) {
      console.error("Customer creation error: ", error);
    }
  };

  // 🔹 Étapes
  const nextStep = () => {
    if (step === 1) {
      createUser();
      createOrder();
    }
    setStep((s) => s + 1);
  };

  const prevStep = () => setStep((s) => s - 1);

  // 🔹 Création de la commande
  const createOrder = async () => {
    const data = new URLSearchParams();
    data.append("locationId", locationId);
    data.append("customerId", customerId);

    panier.forEach((item, index) => {
      const outil = getOutil(item.idOutil);
      if (!outil) return;

      data.append(`line_items[${index}][name]`, outil.nom);
      data.append(`line_items[${index}][quantity]`, item.nombre.toString());
      data.append(
        `line_items[${index}][base_price_money][amount]`,
        outil.prix.toString()
      );
      data.append(
        `line_items[${index}][base_price_money][currency]`,
        "EUR"
      );
    });

    // Frais de livraison
    data.append(`line_items[${panier.length}][name]`, "Frais de livraison");
    data.append(`line_items[${panier.length}][quantity]`, "1");
    data.append(
        `line_items[${panier.length}][base_price_money][amount]`,
        "600"
    );
    data.append(
        `line_items[${panier.length}][base_price_money][currency]`,
        "EUR"
    );

    try {
      const response = await fetch("/backend/order.php", {
        method: "POST",
        headers: { "Content-Type": "application/x-www-form-urlencoded" },
        body: data.toString(),
      });

      if (!response.ok) throw new Error("Payment failed");
      saveCommandeId(response);
    } catch (error) {
      console.error("Payment creation error: ", error);
    }
  };

  const GetTotalAmount = () => {
    return panier.reduce((acc, item) => {
      const outil = getOutil(item.idOutil);
      return outil ? acc + outil.prix * item.nombre : acc;
    }, 0)+livraison*100;
  };

  // 🔹 Rendu JSX
  return (
    <div className="commande-container" onClick={() => setSuggestions([])}>
      {/* ✅ Barre de progression */}
      <div className="progress-container">
        <div
          className="progress-bar"
          style={{ width: `${(step / totalSteps) * 100}%` }}
        ></div>
      </div>

      {step === 1 && (
        <form onSubmit={(e) => { e.preventDefault(); nextStep(); }} className="form-step">
          <div className="form-section">
            <h2>Informations personnelles</h2>
            <div className="grid-form">
              <input type="text" name="nom" placeholder="Nom" value={formData.nom} onChange={handleChange} required />
              <input type="text" name="prenom" placeholder="Prénom" value={formData.prenom} onChange={handleChange} required />
              <input type="email" name="email" placeholder="Email" value={formData.email} onChange={handleChange} required />
              <input type="tel" name="telephone" placeholder="Téléphone" value={formData.telephone} onChange={handleChange} required />
            </div>
          </div>

          <div className="form-section">
            <h2>Adresse de livraison</h2>
            <div className="grid-form">
              <input type="text" name="adresse" placeholder="Adresse" value={formData.adresse} onChange={handleChange} required />
              {suggestions.length > 0 && (
                <ul className="suggestions">
                  {suggestions.map((s, i) => (
                    <li key={i} onClick={() => handleSelectAddress(s)}>
                      {s.label}
                    </li>
                  ))}
                </ul>
              )}
              <input type="text" name="complement" placeholder="Complément d'adresse (optionnel)" value={formData.complement} onChange={handleChange} />
              <input type="text" name="codePostal" placeholder="Code Postal" value={formData.codePostal} onChange={handleChange} required />
              <input type="text" name="ville" placeholder="Ville" value={formData.ville} onChange={handleChange} required />
              <select name="pays" value={formData.pays} disabled>
                <option value="France">France</option>
              </select>
            </div>
          </div>

          <div className="form-button">
            <button type="submit" className="buttonCommande">Suivant</button>
          </div>
        </form>
      )}

      {step === 2 && (
        <div className="form-step">
          <h2>Informations de paiement</h2>
          <SquarePaymentForm
            orderId={orderId}
            customerId={customerId}
            totalAmount={GetTotalAmount()}
            nextStep={nextStep}
            data={formData}
          />
          <div className="form-button">
            <button className="buttonCommande" onClick={prevStep}>
              Précédent
            </button>
          </div>
        </div>
      )}

      {step === 3 && (
        <div className="form-step confirmation-step">
          <h2>Merci pour votre commande !</h2>
          <p>Un email de confirmation a été envoyé à <strong>{formData.email}</strong>.</p>
          <button className="buttonCommande" onClick={() => (window.location.href = "/")}>
            Retour à l'accueil
          </button>
        </div>
      )}
    </div>
  );
}
